// extracted by mini-css-extract-plugin
module.exports = {"add-country":"addcountry_add-country__3bBgP","plus-icon":"addcountry_plus-icon__3h-RR","title":"addcountry_title__1WNvn","price":"addcountry_price__377TS"};